import { axiosClient } from "../api-client";

// type Prop = {
// 	config?: AxiosRequestConfig;
// 	body?: any;
// 	param?: string;
// };

export function SignIn({ body }) {
	return axiosClient.post("/v1/auth/signin", body, {});
}

export function SignUp({ body }) {
	return axiosClient.post("/v1/auth/signup", body, {});
}
export function ConfirmUser({ body }) {
	return axiosClient.post("/v1/auth/confirm/user", body, {});
}
export function TokenRefresh({ body }) {
	return axiosClient.post("/v1/auth/token/refresh", body, {});
}

export function SignInChallenge({ body }) {
	return axiosClient.post("/v1/auth/signin_challenge", body, {});
}

export function sendResetMail({ body }) {
	return axiosClient.post("/v1/auth/password/reset/" + body, {});
}
export function ConfirmChangePassword({ body }) {
	return axiosClient.post("/v1/auth/password/confirm/", body, {});
}

export function GetUserGroupList({ body, config }) {
	return axiosClient.post("/v1/auth/list/groups/user", body, config);
}

export function ChangeUserGroup({ body, config }) {
	return axiosClient.post("/v1/auth/change/groups/user", body, config);
}

export function SuspendUser({ body, config }) {
	return axiosClient.post("/v1/auth/suspend/user", body, config);
}

export function ResendConfirmation({ body, config }) {
	return axiosClient.post(`/v1/auth/confirm/user/resend/${body}`, {}, config);
}
